<si-form-item [label]="placeholder" class="mb-0">
    <div class="flex w-full flex-col gap-2">
        @if (selectedUsers.length > 0) {
            <div class="flex flex-wrap gap-1">
                @for (user of selectedUsers; track user) {
                    <span class="badge rounded-pill text-bg-secondary inline-flex items-center gap-1">
                        {{ getTitle(user) }}
                        <button
                            type="button"
                            class="btn-close btn-close-white"
                            [attr.aria-label]="'a11y-remove' | translate"
                            (click)="remove(user)"
                        ></button>
                    </span>
                }
            </div>
        }

        <ng-template #userItemTemplate let-match="match" siTypeaheadTemplate>
            <span>{{ match.text }}</span>
        </ng-template>

        <div class="relative w-full">
            <input
                class="form-control pr-10"
                [formControl]="userCtrl"
                [hidden]="!multiple && selectedUsers.length === 1"
                [siTypeahead]="scdSearchResult"
                [typeaheadProcess]="false"
                [typeaheadTokenize]="false"
                [typeaheadClearValueOnSelect]="true"
                [typeaheadItemTemplate]="userItemTemplate"
                [typeaheadScrollable]="true"
                [typeaheadOptionsInScrollableView]="6"
                typeaheadOptionField="displayName"
                typeaheadFullWidth
                [placeholder]="hint"
                (typeaheadOnSelect)="onTypeaheadSelect($event)"
                (blur)="blur()"
                #userInput
            />
            @if (isLoading) {
                <si-loading-spinner
                    class="pointer-events-none absolute top-1/2 right-2 -translate-y-1/2"
                    style="font-size: 8px"
                />
            }
        </div>
    </div>
    <ng-content></ng-content>
</si-form-item>
